import { cache, cacheName } from '@/utils/cacheManager'
import { hasCheckRuleCondition, getCheckRuleSetting, saveCheckRuleSetting } from '@/api/sysManage/baseConfig/checkRuleConfig'

export class CheckRuleUtil {
  /**
   * 验证规则配置
   */
  static checkRuleSetting = null

  /**
   * 需要验证规则
   * @param jobUuid
   * @returns {Promise<boolean>}
   */
  static async needCheckRule(checkNode = 0, branchId = 0, useCheckRuleConfigName) {
    if (!cache.config) {
      await cache.load(cacheName.CONFIG)
    }
    const useCheckRule = Number(cache.config.get(useCheckRuleConfigName)) === 1
    if (!useCheckRule) {
      return false
    }
    const hasCheckRule = await hasCheckRuleCondition({ checkNode: checkNode, branchId: branchId }).then(res => res.data)
    return hasCheckRule
  }

  // 获取验证规则设置
  static async getCheckRuleSetting() {
    if (!this.checkRuleSetting) {
      this.checkRuleSetting = await getCheckRuleSetting().then(res => res.data)
    }
    return this.checkRuleSetting
  }

  // 保存验证规则设置
  static async saveCheckRuleSetting(data) {
    await saveCheckRuleSetting(data)
    this.checkRuleSetting = null
  }
}
